export function formatCamelToSentenceCase(text: string) {
  const spacedText = text.replace(/([A-Z])/g, ' $1').toLowerCase();
  return spacedText[0].toUpperCase() + spacedText.slice(1);
}

export function formatStringToTitleCase(text: string) {
  return text.charAt(0).toUpperCase() + text.slice(1);
}
